<header class="profile-toolbar">
  <nav
    class="profile-segments"
    [attr.aria-label]="'app.components.profile.sectionsLabel' | translate"
  >
    <button
      type="button"
      class="profile-segments__btn"
      [class.profile-segments__btn--active]="selectedTab() === 'general'"
      (click)="selectTab('general')"
    >
      {{ 'app.components.profile.general' | translate }}
    </button>

    <button
      type="button"
      class="profile-segments__btn"
      [class.profile-segments__btn--active]="selectedTab() === 'settings'"
      (click)="selectTab('settings')"
    >
      {{ 'app.components.profile.settings' | translate }}
    </button>

    @if (showSubscriptions()) {
      <button
        type="button"
        class="profile-segments__btn"
        [class.profile-segments__btn--active]="selectedTab() === 'subscriptions'"
        (click)="selectTab('subscriptions')"
      >
        {{ 'app.components.profile.subscriptions' | translate }}
      </button>
    }
  </nav>
</header>
